<template>
<div class="large-text vh-for-mobile" :style="{'background-color': bgColor}">
	<div class="large-text__wrapper" v-observe-visibility="{
			callback: fadeInView,
			intersection: {
				threshold: 0.3
			}
		}">
		<h2 :style="{'color': textColor}">{{ text }}</h2>
	</div>
</div>
</template>

<script>
const CLASS_IDENTIFIER = 'vh-for-mobile'
const DELAY = 300

class VHForMobile {
	constructor($parent = document.body) {
		this.$parent = $parent

		this.updateChildren = this.updateChildren.bind(this)
		this.updateView = this.updateView.bind(this)

		this.updateChildren()
		this.updateView()

		window.addEventListener('orientationchange', this.updateView)
	}

	updateChildren() {
		const nodeList = this.$parent.getElementsByClassName(CLASS_IDENTIFIER)
		this.$children = Array.prototype.slice.call(nodeList)
	}

	updateView() {
		this.$children.forEach($child => {
			$child.style.removeProperty('height')

			setTimeout(() => {
				$child.style.height = $child.clientHeight + 'px'
			}, DELAY)
		})
	}
}

export default {
	name: 'CaseViewLargeText',
	props: {
		text: String,
		bgColor: String,
		textColor: String
	},
	methods: {
		fadeInView(isVisible, entry) {
			if (isVisible) {
				Object.assign(entry.target.style, {
					transition: 'all 1s cubic-bezier(0.215, 0.61, 0.355, 1)',
					opacity: '1',
					transform: 'translateY(0)'
				})
			} else if (entry.boundingClientRect.bottom > window.innerHeight) {
				Object.assign(entry.target.style, {
					opacity: '0',
					transform: 'translateY(5em)'
				})
			} else {
				Object.assign(entry.target.style, {
					opacity: '0'
				})
			}
		}
	},
	mounted() {
		new VHForMobile()
	}
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

.large-text {
    height: 75vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $margin2-1 $margin1-2;
    box-sizing: border-box;
    @media screen and (min-width: 550px) {
        padding: $margin2-1 $margin1-1;
    }
    @media screen and (min-width: 1025px) {
        height: 100vh;
    }

    &__wrapper {
        text-align: center;

        h2 {
            font-family: $font-expanded;
            font-size: $font-size-m;
            line-height: 1.2em;
            text-align: center;
            @media screen and (min-width: 440px) {
                font-size: $font-size-l;
            }
            @media screen and (min-width: 1050px) {
                font-size: $font-size-xl;
            }
        }
    }
}
</style>
